import React from 'react';
import styled from '@emotion/styled';
import { css, cx } from '@emotion/css';

import { parseHtml } from '../helpers';

import { ComponentStyle } from '../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

import { productComponentContainerPaddingStyle } from '../shared/styles';

const TitleContainer = styled.div([
  productComponentContainerPaddingStyle,
  {
    '&.A': {
      paddingBottom: pxToRem(16),

      [mqBreakpoints.tablet]: {
        paddingBottom: pxToRem(32),
      },

      [mqBreakpoints.desktop]: {
        paddingTop: pxToRem(96),
      },
    },

    // This is styling for the Landing Page Header
    '&.B': {
      p: {
        fontSize: pxToRem(20),
        lineHeight: pxToRem(28),
        paddingBottom: pxToRem(24),

        [mqBreakpoints.tablet]: {
          paddingBottom: pxToRem(48),
        },

        p: {
          marginTop: pxToRem(32),
          paddingBottom: 0,

          [mqBreakpoints.tablet]: {
            marginTop: pxToRem(64),
          },

          [mqBreakpoints.desktop]: {
            marginTop: pxToRem(48),
          },
        },
      },
    },
  },
]);

const headingStyle = css({
  color: 'var(--color-secondary)',
  maxWidth: '90rem',
});

type Props = {
  title: string;
  strapline?: string;
  style: ComponentStyle;
};

export const HeaderTitle: React.FC<Props> = ({ title, strapline, style }) => {
  const Heading = props => (style === ComponentStyle.A ? <h1 {...props} className={cx(props.className, 'display-2')}></h1> : <h1 {...props} className={cx(props.className, 'display-4-light display-4-light-all')}></h1>);

  return (
    <TitleContainer className={style}>
      <Heading className={headingStyle} data-testid='mp-product-header-title'>
        {parseHtml(title, {
          allowedTags: ['br'],
        })}
      </Heading>
      {strapline ? (
        <p className='strapline' data-testid='mp-product-header-description'>
          {parseHtml(strapline, {
            allowedAttributes: {
              span: ['style'],
            },
          })}
        </p>
      ) : null}
    </TitleContainer>
  );
};
